import { TaxonomyTerm } from '../entities/category';
import { Language } from '../entities/language';

export abstract class CategoryRepository {
  abstract findAll(language: Language): Promise<readonly TaxonomyTerm[]>;
}
